"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxValue = exports.minValue = exports.input = void 0;

var _util = require("../../../util");

const input = ({
  theme
}) => ({
  nested: {
    '& input': {
      minWidth: 200,
      textAlign: 'center',
      '&::placeholder': {
        color: (0, _util.color)(theme, 'disabled.2')
      }
    }
  }
});

exports.input = input;

const minValue = () => ({
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translate(0, -50%)'
});

exports.minValue = minValue;

const maxValue = () => ({
  position: 'absolute',
  right: 12,
  top: '50%',
  transform: 'translate(0, -50%)'
});

exports.maxValue = maxValue;
//# sourceMappingURL=NumberField.style.js.map